import { cn } from '@/lib/utils';

interface ITabItem {
  label: string;
  count: { value: number | null; color: string };
}

interface IProps {
  label: string;
  pathname: string;
  activeLink: boolean;
  navigate: any;
}

export function NavbarItem({ label, pathname, activeLink, navigate }: IProps) {
  return (
    <button
      className={cn(
        'relative flex items-center gap-2 px-4 pt-4 pb-3.5 text-sm font-semibold duration-300 border-b-4 border-b-transparent',
        activeLink ? 'border-green-default' : '',
      )}
      onClick={() => navigate(pathname)}
    >
      <span className="whitespace-nowrap text-white">{label}</span>
    </button>
  );
}
